export class PlanAccionModel {
  id?:string;
  tienda?:string = "";
  semana?: string = "";
  empleado?: string = "";
  indicador?:number;
  nombreInd?:string = "";
  estado?:EstadoPlanAccion;
  comentario?:string = "";
  actividadMejoramiento?:string = "";
  retroalimentacion?:string = "";
  valorIndicador?:number = 0;
  valorTienda?:number = 0;
  archivo?:string = "";
  ventaEmpleado?:number = 0;
  ventaTienda?:number = 0;


  constructor(){
    this.estado = new EstadoPlanAccion();
  }
}

export class EstadoPlanAccion {
  creado?: number = 0;
  activo?: number = 0;
  cerrado?: number = 0;
  completado?: number = 0;
}
